/**
 * Namespace `common` — chữ DÙNG CHUNG nhiều trang + nhãn của các bảng trong `@bube-hq/contracts`
 * (`CONNECTOR_STATUS_LABEL`, `PERIOD_LABEL`…). Contracts giữ nhãn tiếng Việt cho máy chủ / log; giao diện đọc ở đây.
 */
export const common = {
  stateOn: "Đang bật",
  stateOff: "Đang tắt",
  loading: "Đang đọc…",
  save: "Lưu",
  saving: "Đang lưu…",
  cancel: "Huỷ",
  close: "Đóng",
  confirm: "Xác nhận",
  edit: "Sửa",
  delete: "Xoá",
  retry: "Thử lại",
  refresh: "Làm mới",
  back: "Quay lại",
  search: "Tìm",
  none: "—",
  yes: "Có",
  no: "Không",
  allApps: "Tất cả app",
  noData: "Chưa có dữ liệu.",
  loadFailed: "Không đọc được dữ liệu.",
  saveFailed: "Không lưu được.",
  noPermission: "Bạn không có quyền xem mục này.",

  // HQ-2026-009 — `errorElement` của router: lỗi khi vẽ trang / đường dẫn không tồn tại.
  "routeError.title": "Trang này gặp lỗi",
  "routeError.body": "Lỗi đã được ghi lại để đội kỹ thuật xem. Thử tải lại trang; nếu vẫn lỗi, quay về trang đầu.",
  "routeError.notFoundTitle": "Không có trang này",
  "routeError.notFoundBody": "Đường dẫn không tồn tại hoặc đã đổi.",
  "routeError.reload": "Tải lại trang",
  "routeError.home": "Về trang đầu",
  "routeError.detail": "Chi tiết kỹ thuật",

  "connectorStatus.ok": "Đang chạy",
  "connectorStatus.not_configured": "Chưa cấu hình",
  "connectorStatus.unreachable": "Không kết nối được",
  "connectorStatus.schema_drift": "Lệch schema",
  "connectorStatus.never_run": "Chưa chạy lần nào",
  "connectorStatus.disabled": "Đã tắt",

  "criticality.tier_0": "Trọng yếu",
  "criticality.tier_1": "Quan trọng",
  "criticality.tier_2": "Thường",
  "criticality.tier_3": "Phụ trợ",

  "ownerKind.product": "Sản phẩm",
  "ownerKind.engineering": "Kỹ thuật",
  "ownerKind.operations": "Vận hành",
  "ownerKind.security": "An toàn",
  "ownerKind.business": "Kinh doanh",

  "feedbackStatus.open": "Đang mở",
  "feedbackStatus.in_progress": "Đang xử lý",
  "feedbackStatus.resolved": "Đã xong",

  "role.hq.viewer": "Chỉ đọc",
  "role.hq.operator": "Vận hành",
  "role.hq.owner": "Chủ",

  "audienceMetric.users.total": "Tổng người dùng",
  "audienceMetric.users.new": "Người dùng mới",
  "audienceMetric.users.active": "Người dùng hoạt động",

  "period.today": "Hôm nay",
  "period.yesterday": "Hôm qua",
  "period.d7": "7 ngày qua",
  "period.this_week": "Tuần này",
  "period.last_week": "Tuần trước",
  "period.d30": "30 ngày qua",
  "period.this_month": "Tháng này",
  "period.last_month": "Tháng trước",
  "period.d90": "90 ngày qua",
  "period.custom": "Tuỳ chọn…",

  "partnerCategory.einvoice": "Hoá đơn điện tử",
  "partnerCategory.bank_feed": "Biến động số dư",
  "partnerCategory.payment": "Cổng thanh toán",
  "partnerCategory.shipping": "Vận chuyển",
  "partnerCategory.esign": "Chữ ký số",
  "partnerCategory.messaging": "Tin nhắn",
  "partnerCategory.tax": "Thuế",
  "partnerCategory.marketplace": "Sàn TMĐT",
  "partnerCategory.identity": "Đăng nhập",
  "partnerCategory.email": "Email",
  "partnerCategory.push": "Thông báo đẩy",
  "partnerCategory.ai": "AI",
  "partnerCategory.other": "Khác",

  networkError: "Không gọi được máy chủ. Kiểm tra kết nối rồi thử lại.",
  unexpectedErrorShape: "Máy chủ trả {status} với một hình dạng không phải vỏ lỗi của hub.",
  contractMismatch: "Phản hồi của {path} không khớp hợp đồng: {issue}",
  unknownIssue: "không rõ",

  "metric.users.total": "Tổng người dùng",
  "metric.users.new": "Người dùng mới",
  "metric.users.active": "Người dùng hoạt động",
  "metric.subscriptions.count": "Số thuê bao",
  "metric.revenue.net": "Doanh thu ghi nhận",
  "metric.storage.bytes": "Dung lượng",
  "metric.service.latency_p50": "Độ trễ trung vị",
} as const;
